import { cva, VariantProps } from 'class-variance-authority';

export const dropdownContentVariants = cva('bg-popover text-popover-foreground z-50 min-w-[200px] overflow-y-auto rounded-br-2xl rounded-bl-2xl  border p-2 flex flex-col gap-1 shadow-card-button');

export const dropdownItemVariants = cva(
  'relative flex cursor-pointer select-none items-center font-semibold gap-2 text-[14px] rounded-md p-2 outline-none transition-colors hover:bg-muted hover:text-foreground dark:hover:bg-muted/50 focus:bg-muted focus:text-foreground dark:focus:bg-muted/50 focus-visible:bg-muted focus-visible:text-foreground dark:focus-visible:bg-muted/50 data-[highlighted]:bg-muted data-[highlighted]:text-foreground dark:data-[highlighted]:bg-muted/50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: '',
        destructive: 'text-destructive hover:bg-destructive/10 focus:bg-destructive/10 dark:hover:bg-destructive/20 dark:focus:bg-destructive/20 focus:text-destructive',
      },
      inset: {
        true: 'pl-8',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      inset: false,
    },
  },
);

export const dropdownLabelVariants = cva('relative flex items-center px-2 py-1.5 text-[14px] font-medium text-muted-foreground', {
  variants: {
    inset: {
      true: 'pl-8',
      false: '',
    },
  },
  defaultVariants: {
    inset: false,
  },
});

export const dropdownShortcutVariants = cva('ml-auto text-xs tracking-widest text-muted-foreground');

export type ZardDropdownItemVariants = VariantProps<typeof dropdownItemVariants>;
export type ZardDropdownLabelVariants = VariantProps<typeof dropdownLabelVariants>;
